var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({attrs:{"filled":_vm.filled,"type":"number","step":_vm.step,"min":_vm.min,"max":_vm.max,"persistent-hint":""},on:{"change":_vm.change,"input":_vm.update}},'v-text-field',_vm.commonProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }